export default {

  doTxCenterAverage (data, query, numeratorField, denominatorField, txCenterId, useMulti) {
    var years = []
    var hist = []
    var hist1a = []
    var hist1b = []
    var hist2 = []

    if (useMulti) {
      numeratorField += (query.organMode === 'multi' ? '_multi' : '_single')
      denominatorField += (query.organMode === 'multi' ? '_multi' : '_single')
    }

    data.forEach(function (item) {
      if (item.tx_ctr_id === txCenterId) {
        years.push(item.year)
        hist.push(item[numeratorField] / item[denominatorField])
        hist1a.push(item[numeratorField + '_1a'] / item[denominatorField + '_1a'])
        hist1b.push(item[numeratorField + '_1b'] / item[denominatorField + '_1b'])
        hist2.push(item[numeratorField + '_2'] / item[denominatorField + '_2'])
      }
    })

    return { years, hist, hist1a, hist1b, hist2 }
  },

  tx_stat_1 (data, query, txCenterId) {
    return this.doTxCenterAverage(data, query, 'recipients', 'candidates', txCenterId, true)
  },

  tx_stat_2 (data, query, txCenterId) {
    return this.doTxCenterAverage(data, query, 'offers_declined', 'offers', txCenterId, false)
  },

  tx_stat_4 (data, query, txCenterId) {
    return this.doTxCenterAverage(data, query, 'offers_accepted_lq', 'offers_accepted', txCenterId, false)
  },

  tx_stat_5 (data, query, txCenterId) {
    return this.doTxCenterAverage(data, query, 'offers_accepted_mq', 'offers_accepted', txCenterId, false)
  },

  tx_stat_6 (data, query, txCenterId) {
    return this.doTxCenterAverage(data, query, 'offers_accepted_hq', 'offers_accepted', txCenterId, false)
  },

  tx_stat_7 (data, query, txCenterId) {
    return this.doTxCenterAverage(data, query, 'sumischemic', 'recipients', txCenterId, true)
  },

  tx_stat_8 (data, query, txCenterId) {
    return this.doTxCenterAverage(data, query, 'sumwaiting', 'recipients', txCenterId, true)
  },

  tx_stat_9 (data, query, years, txCenterId) {
    return this.doTxCenterAverage(data, query, 'dead' + years + 'yr', 'recipients', txCenterId, true)
  },

  tx_stat_9_1 (data, query, txCenterId) {
    return this.tx_stat_9(data, query, '1', txCenterId)
  },

  tx_stat_9_3 (data, query, txCenterId) {
    return this.tx_stat_9(data, query, '3', txCenterId)
  },

  tx_stat_9_5 (data, query, txCenterId) {
    return this.tx_stat_9(data, query, '5', txCenterId)
  },

  tx_stat_10 (data, query, years, txCenterId) {
    return this.doTxCenterAverage(data, query, 'fail' + years + 'yr', 'recipients', txCenterId, true)
  },

  tx_stat_10_1 (data, query, txCenterId) {
    return this.tx_stat_10(data, query, '1', txCenterId)
  },

  tx_stat_10_3 (data, query, txCenterId) {
    return this.tx_stat_10(data, query, '3', txCenterId)
  },

  tx_stat_10_5 (data, query, txCenterId) {
    return this.tx_stat_10(data, query, '5', txCenterId)
  }

}



// WEBPACK FOOTER //
// ./src/api/txc.js